import type { Professions } from '@mezha/api'
import { baseApi } from '../baseApi'

export const professionsApi = baseApi.injectEndpoints({
  endpoints: b => ({
    professions: b.query<Professions, void>({
      query: () => ({ get: '/api/v1/professions' }),
      providesTags: ['Professions'],
    }),
  }),
})
export const { useProfessionsQuery } = professionsApi
